<template>
	<div class="leftbar-wrapper">
		<v-navigation-drawer
			class="leftbar"
			permanent
			dark
			absolute
			color="secondary"
			mini-variant
			stateless
			height="calc(100% - 46px)"
			mini-variant-width="80"
		>
			<v-list nav class="pa-0" tile>
				<v-list-item-group :value="selected" @change="onChange">
					<v-list-item
						v-for="(item, i) in items"
						:key="`item-${i}`"
						class="pa-2"
						active-class="leftbar-item-active"
					>
						<v-list-item-icon class="d-block text-center ma-0">
							<div><app-icon :icon="item.icon" /></div>
							<div class="caption">{{ item.text }}</div>
						</v-list-item-icon>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
		<div class="leftbar-panel pa-4" v-if="selected >= 0">
			<!-- v-show (not v-if) so switching tools does not destroy slot content (e.g. page assistant chat). -->
			<div
				v-for="(item, i) in items"
				:key="`leftbar-item-${i}`"
				v-show="selectedItem.value === item.value"
				class="leftbar-item"
			>
				<slot :name="item.value" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		value: {
			type: Number,
		},
	},
	computed: {
		selected() {
			return this.value
		},
		selectedItem() {
			return this.items[this.value]
		},
	},
	methods: {
		onChange(event) {
			this.$emit('input', event)
			this.$emit('change', event)
		},
	},
}
</script>

<style scoped>
	.leftbar {
		top: 46px !important;
	}

	.leftbar .leftbar-item-active, .leftbar .leftbar-item-active:before {
		border-radius: 0px;
		background-color: white;
		color: var(--v-secondary-base);
	}

	.leftbar-panel {
		position: absolute;
		top: 46px;
		bottom: 0;
		width: 400px;
		background: white;
    left: 80px;
		border: 1px solid #e6e6e6;
	}
</style>
